import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  menuItems = this.commonService.menus;
  showSubMenu:boolean = false;
  activeLink;
  constructor(private router: Router,private commonService:CommonService) { }

  ngOnInit(): void {
    this.setMenu();
  }
  setMenu() {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const userRights = userDetails.roleDetails.rights;
    const roleType = userDetails.roleDetails.roleInfo;
    this.menuItems.forEach((element:any) => {
      element.isRight = userRights[element.previlageId];
      
      // Override for Org Admin to only show Catalogue and Pathway for ORG100346
      if (roleType?.roleId === "wzaqrin") {
        if (element.name === "Catalogue" || element.name === "Pathway" || element.name === "Assign Pathway") {
          element.isRight = (userDetails?.orgId === "ORG100346");
        }
      }

      if(element?.subMenu?.length > 0) {
        element.subMenu =  element.subMenu.filter((ele)=>{
          ele.isRights = userRights[ele.previlageId];
          if(roleType.roleId == "wzaqrin" && ele.name == "User Performance Report"){
            ele.link = '/core/report/educatereport';
            ele.queryParams = {
              orgid: userDetails?.orgId,
              orgname: btoa(userDetails?.orgName),
              type: "Org Admin"
            }
          }
          return !(userDetails.orgTrack && ele.name == "Course Completion Report");
        })
      }
    });
  }

  subMenuClick(subMenu: any) {
    this.menuItems.map((parent) => {
      parent.active = false;
      if (parent.subMenu) {
        parent.subMenu.map((child) => (child.active = false));
      }
      if (parent.subMenu) {
        parent.subMenu.map((child) => {
          if (child.name === subMenu.name) {
            parent.active = true;
            child.active = true;
          }
        });
      }
    });
    if (subMenu.queryParams) {
      this.router.navigate([subMenu.link], {
        queryParams: subMenu.queryParams
      });
    } else {
      this.router.navigate([subMenu.link]);
    }
  }
}
